export default __webpack_public_path__ + "static/media/banner.a37fda54.jpg";